import React, { useEffect, useState } from "react";
// import morrisonsLogo from "assets/images/morrisons-logo.png";
import {
  Backdrop,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";
import { PoEnquirycolumnDefs } from "components/DataGrid/columnDefinitions";
import { DataGrid } from "components/DataGrid/DataGrid";
import { useNavigate, useSearchParams } from "react-router-dom";
import { LabelWithControl } from "components/common/LabelControl";
import { encryptString } from "components/common/EncryptDecrypt";
import { searchPO, searchPOReset } from "redux/actions/searchPOAction";
import { useDispatch, useSelector } from "react-redux";
import jsPDF from "jspdf";
import ReactDOM from "react-dom/client";
import {
  convertToCamelCase,
  getDestinationName,
  getFormattedDate,
} from "components/common/Utility";
import { PAGE, PO_ITEM_STATUS, PO_STATUS } from "components/common/CONSTANTS";

export const ManualPurchaseOrderEnquiry = () => {
  const [queryParams] = useSearchParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userType = useSelector((state) => state.user);
  const { locationResponse } = useSelector((state) => state.locations);
  const searchPoReducer = useSelector((state) => state.searchPO);
  const [showSpinner, setShowSpinner] = useState(false);
  const [poDetails, setPODetails] = useState();
  const [poItems, setPOItems] = useState([]);

  const [loading, setLoading] = useState(false);

  const handleDownloadPDF = () => {
    setLoading(true);
    setShowSpinner(true);
    const hiddenDiv = document.createElement("div");

    document.body.appendChild(hiddenDiv);
    const root = ReactDOM.createRoot(hiddenDiv);
    root.render(
      <POPDFContent poDetails={poDetails} locationResponse={locationResponse} />
    );
    const pdf = new jsPDF("p", "mm", "a4");

    pdf.html(hiddenDiv, {
      callback: function (doc) {
        root.unmount();
        document.body.removeChild(hiddenDiv);
        setLoading(false);
        setShowSpinner(false);
        doc.save(`PO-${poDetails?.poIdentifier || "download"}.pdf`);
      },
      margin: [10, 10, 10, 10],
      autoPaging: "text",
      x: 0,
      y: 0,
      width: 190,
      windowWidth: hiddenDiv.scrollWidth,
    });
  };
  const [dialog, setDialog] = useState(false);

  const openComments = () => {
    setDialog(true);
  };

  const closeComments = () => {
    setDialog(false);
  };

  useEffect(() => {
    const poNo = queryParams.get("poNo");
    const searchCriteria = {
      extOrderId: poNo,
    };
    callSearchPOApi(searchCriteria);
  }, []); //eslint-disable-line react-hooks/exhaustive-deps

  const callSearchPOApi = async (searchCriteria) => {
    const encryptedEmailId = await encryptString(userType.loginResponse?.email);
    const payload = {
      params: {
        purchaseOrder: searchCriteria,
        userId: encryptedEmailId,
      },
      limit: 1,
      offset: 0,
    };
    dispatch(searchPO(payload));
  };

  useEffect(() => {
    if (searchPoReducer.isSearchLoading) {
      setShowSpinner(true);
    } else if (searchPoReducer.isSearchSuccess) {
      setShowSpinner(false);

      const poResponse = searchPoReducer.searchPOResponse.data[0];
      if (poResponse.shipToLocationName) {
        setPODetails({
          ...poResponse,
          poIdentifier: poResponse.orderId
            ? poResponse.orderId
            : poResponse.extOrderId,
        });
      } else {
        setPODetails({
          ...poResponse,
          poIdentifier: poResponse.orderId
            ? poResponse.orderId
            : poResponse.extOrderId,
          shipToLocationName: getDestinationName(
            locationResponse,
            poResponse.shipToLocationId
          ),
        });
      }

      const items = poResponse.items.filter(
        (item) => poResponse.status === PO_STATUS.CANCELLED || item.status !== PO_ITEM_STATUS.REMOVE
      );

      setPOItems(items);
      dispatch(searchPOReset());
    } else if (searchPoReducer.isSearchFail) {
      setShowSpinner(false);
      dispatch(searchPOReset());
    }
  }, [searchPoReducer]); //eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="mainPageStyling">
      {showSpinner && (
        <Backdrop
          sx={{
            color: "#fff",
            flexDirection: "column",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={true}
        >
          <CircularProgress color="inherit" />

          <Typography variant="h6" sx={{ marginTop: 2 }}>
            Loading...
          </Typography>
        </Backdrop>
      )}
      <div style={{ display: "flex", alignItems: "center" }}>
        <Typography component="h1" variant="h5" sx={{ mb: 2, mr: 2 }}>
          {PAGE.PO_ENQUIRY.label}
        </Typography>
      </div>
      <div className="poHeaderStyling">
        <Grid sx={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
          <Grid container spacing={2} sx={{ "& > *": { flex: 1 } }}>
            <Grid item xs={12} sm={6} md={2}>
              <LabelWithControl label="Supplier" labelId="supplier">
                <Typography id="supplier">{`${poDetails?.supplierId} ${poDetails?.supplierName}`}</Typography>
              </LabelWithControl>
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <LabelWithControl label="Destination" labelId="destination">
                <Typography id="destination">
                  {`${poDetails?.shipToLocationId} ${poDetails?.shipToLocationName}`}
                </Typography>
              </LabelWithControl>
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <LabelWithControl label="Status" labelId="status">
                <Typography id="status">
                  {convertToCamelCase(poDetails?.status)}
                </Typography>
              </LabelWithControl>
            </Grid>
            <Grid item xs={12} sm={6} md={1}>
              <LabelWithControl label="Handball" labelId="handball">
                <Typography id="handball">
                  {poDetails?.isHandball ? "Yes" : "No"}
                </Typography>
              </LabelWithControl>
            </Grid>
            <Grid item xs={12} sm={6} md={1}>
              <LabelWithControl label="Import" labelId="import">
                <Typography id="import">
                  {poDetails?.isOverseas ? "Yes" : "No"}
                </Typography>
              </LabelWithControl>
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <LabelWithControl
                label="PO Delivery Method"
                labelId="poDeliveryMethod"
              >
                <Typography id="poDeliveryMethod">
                  {poDetails?.deliveryMethod}
                </Typography>
              </LabelWithControl>
            </Grid>

            <Grid item xs={12} sm={6} md={2}>
              <LabelWithControl
                label="Pallets per Wagon"
                labelId="palletPerWagon"
              >
                <Typography id="palletPerWagon">
                  {poDetails?.palletPerWagon}
                </Typography>
              </LabelWithControl>
            </Grid>
          </Grid>
        </Grid>
      </div>
      <div className="poHeaderStyling">
        <Grid sx={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
          <Grid container spacing={2} sx={{ "& > *": { flex: 1 } }}>
            <Grid item xs={12} sm={6} md={2}>
              <LabelWithControl label="PO Identifier" labelId="poIdentifier">
                <Typography id="poIdentifier">
                  {poDetails?.poIdentifier}
                </Typography>
              </LabelWithControl>
            </Grid>
            <Grid item xs={12} sm={6} md={1.5}>
              <LabelWithControl label="Order Date" labelId="orderDate">
                <Typography id="orderDate">
                  {getFormattedDate(poDetails?.orderDate)}
                </Typography>
              </LabelWithControl>
            </Grid>
            <Grid item xs={12} sm={6} md={1.5}>
              <LabelWithControl label="DeliveryDate" labelId="deliveryDate">
                <Typography id="deliveryDate">
                  {getFormattedDate(poDetails?.deliveryDate)}
                </Typography>
              </LabelWithControl>
            </Grid>
            <Grid item xs={12} sm={6} md={1}>
              <LabelWithControl label="Comments" labelId="comments">
                <Button
                  onClick={openComments}
                  className="linkButton"
                  style={{ maxWidth: "60px" }}
                >
                  View
                </Button>
              </LabelWithControl>
            </Grid>
            <Grid item xs={12} sm={6} md={1.5}>
              <LabelWithControl label="Total cases" labelId="totalCases">
                <Typography id="totalCases">
                  {poDetails?.totalCasesCount}
                </Typography>
              </LabelWithControl>
            </Grid>

            <Grid item xs={12} sm={6} md={1.5}>
              <LabelWithControl label="Total pallets" labelId="totalPallets">
                <Typography id="totalPallets">
                  {poDetails?.totalPalletCount}
                </Typography>
              </LabelWithControl>
            </Grid>
            <Grid item xs={12} sm={6} md={1.5}>
              <LabelWithControl label="Total bases" labelId="totalbases">
                <Typography id="totalBases">
                  {poDetails?.totalBasesCount}
                </Typography>
              </LabelWithControl>
            </Grid>
            <Grid item xs={12} sm={6} md={1.5}>
              <LabelWithControl label="Total Wagons" labelId="totalWagons">
                <Typography id="totalWagons">
                  {poDetails?.totalWagonsCount}
                </Typography>
              </LabelWithControl>
            </Grid>
          </Grid>
        </Grid>
      </div>
      <div style={{ width: "100%", height: "calc( 100vh - 335px)" }}>
        <DataGrid
          columnDefs={PoEnquirycolumnDefs}
          rowData={poItems}
          defaultColDef={{
            flex: 1,
            sortable: false,
            filter: false,
            resizable: false,
            wrapHeaderText: true,
            autoHeaderHeight: true,
            headerClass: "header-wrap",
            autoSizeStrategy: { type: "fitCellContents" },
          }}
        />
      </div>

      <div className="parentPoButtons">
        <Button
          className="commonPOButtons"
          variant="contained"
          color="primary"
          onClick={handleDownloadPDF}
          style={{
            marginRight: "8px",
          }}
          disabled={loading}
        >
          {loading ? "Generating PDF..." : "Download as PDF"}
        </Button>

        <Button
          className="commonPOButtons"
          variant="contained"
          color="secondary"
          onClick={() =>
            navigate(PAGE.PO_SUMMARY.url, {
              state: {
                retainSearchCriteria: true,
              },
            })
          }
        >
          Back
        </Button>
      </div>
      <Dialog open={dialog} onClose={closeComments}>
        <div className="dialogStyling">
          <DialogTitle>Comments</DialogTitle>
          <DialogContent>
            <ul style={{ margin: "0", padding: "0 20px", fontSize: "12px" }}>
              <li>
                {poDetails?.userComments
                  ? poDetails?.userComments
                  : "No comments"}
              </li>
            </ul>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              color="primary"
              onClick={closeComments}
              className="commonPOButtons"
            >
              Close
            </Button>
          </DialogActions>
        </div>
      </Dialog>
    </div>
  );
};
//  PDF-only hidden component
const POPDFContent = ({ poDetails, locationResponse }) => (
  <div style={{ fontFamily: "Arial, sans-serif", padding: 20 }}>
    <hr style={{ margin: "0", border: "2px solid black" }} />

    <table
      style={{
        width: "100%",
        borderCollapse: "collapse",
        marginTop: "10px",
        marginBottom: "20px",
      }}
    >
      <thead>
        <tr>
          <td colSpan="3" style={{ paddingBottom: "8px" }}>
            <p
              style={{
                fontWeight: "bold",
                fontSize: "24px",
                marginBottom: "0",
              }}
            >
              Purchase Order No.: {poDetails?.poIdentifier}
            </p>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr>
          {/* Registered Office */}
          <td style={{ width: "33%", verticalAlign: "top", padding: "8px" }}>
            <div
              style={{
                fontWeight: "bold",
                fontSize: "16px",
                marginBottom: "4px",
              }}
            >
              Registered Office:
            </div>
            <div>
              Wm Morrison Supermarkets LTD <br />
              Hilmore House, Gain Lane,
              <br />
              Bradford BD3 7DL
            </div>
          </td>

          {/* Order Query */}
          <td style={{ width: "34%", verticalAlign: "top", padding: "8px" }}>
            <div
              style={{
                fontWeight: "bold",
                fontSize: "16px",
                marginBottom: "4px",
              }}
            >
              Order Query:
            </div>
            <div>
              In case of order query please telephone:
              <br />
              Fresh 0845 611 5000 /<br />
              Ambient 0845 611 5601
            </div>

            {(poDetails?.status === "amended" ||
              poDetails?.status === "somsAmended") && (
              <div style={{ marginTop: "8px" }}>
                <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                  Amendment Indicator:
                </span>
                <span
                  style={{
                    display: "inline-block",
                    width: "8px",
                    height: "16px",
                    borderBottom: "2px solid black",
                    borderRight: "2px solid black",
                    transform: "rotate(45deg)",
                    marginLeft: "6px",
                  }}
                />
              </div>
            )}
          </td>

          {/* Logo Placeholder */}
          <td
            style={{
              width: "33%",
              verticalAlign: "top",
              padding: "8px",
              textAlign: "right",
            }}
          >
            {/* <img alt="Morrisons" src={morrisonsLogo} style={{ maxHeight: "50px" }} /> */}
          </td>
        </tr>
      </tbody>
    </table>
    <hr style={{ margin: "0 0 20px", border: "2px solid black" }} />

    <table
      style={{
        width: "100%",
        borderCollapse: "separate",
        borderSpacing: "10px",
        marginTop: "10px",
        marginBottom: "20px",
      }}
    >
      <tbody>
        <tr>
          {/* Purchase Order Information */}
          <td
            style={{
              width: "25%",
              border: "1px solid black",
              padding: "8px",
              verticalAlign: "top",
              backgroundColor: "#fff",
            }}
          >
            <div
              style={{
                fontWeight: "bold",
                fontSize: "16px",
                lineHeight: "20px",
              }}
            >
              Purchase Order Information
            </div>
            <hr
              style={{
                border: "none",
                borderTop: "1px solid black",
                margin: "4px 0 8px 0",
              }}
            />
            <table style={{ width: "100%", fontSize: "14px" }}>
              <tbody>
                <tr>
                  <td style={{ fontWeight: "bold", padding: "4px 0" }}>
                    Purchase Order No:
                  </td>
                  <td style={{ padding: "4px 0" }}>
                    {poDetails?.poIdentifier}
                  </td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold", padding: "4px 0" }}>
                    Order Date:
                  </td>
                  <td style={{ padding: "4px 0" }}>
                    {getFormattedDate(poDetails?.orderDate)}
                  </td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold", padding: "4px 0" }}>
                    Delivery Date:
                  </td>
                  <td style={{ padding: "4px 0" }}>
                    {getFormattedDate(poDetails?.deliveryDate)}
                  </td>
                </tr>
              </tbody>
            </table>
          </td>

          {/* Supplier Information */}
          <td
            style={{
              width: "25%",
              border: "1px solid black",
              padding: "8px",
              verticalAlign: "top",
              backgroundColor: "#fff",
            }}
          >
            <div
              style={{
                fontWeight: "bold",
                fontSize: "16px",
                lineHeight: "20px",
              }}
            >
              Supplier Information
            </div>
            <hr
              style={{
                border: "none",
                borderTop: "1px solid black",
                margin: "4px 0 8px 0",
              }}
            />
            <table style={{ width: "100%", fontSize: "14px" }}>
              <tbody>
                <tr>
                  <td style={{ fontWeight: "bold", padding: "4px 0" }}>
                    Order To:
                  </td>
                  <td style={{ padding: "4px 0" }}>
                    {poDetails?.supplierName}
                  </td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold", padding: "4px 0" }}>
                    Supplier Site:
                  </td>
                  <td style={{ padding: "4px 0" }}>{poDetails?.supplierId}</td>
                </tr>
              </tbody>
            </table>
          </td>

          {/* Order Quantity Totals */}
          <td
            style={{
              width: "25%",
              border: "1px solid black",
              padding: "8px",
              verticalAlign: "top",
              backgroundColor: "#fff",
            }}
          >
            <div
              style={{
                fontWeight: "bold",
                fontSize: "16px",
                lineHeight: "20px",
              }}
            >
              Order Quantity Totals
            </div>
            <hr
              style={{
                border: "none",
                borderTop: "1px solid black",
                margin: "4px 0 8px 0",
              }}
            />
            <table style={{ width: "100%", fontSize: "14px" }}>
              <tbody>
                <tr>
                  <td
                    style={{
                      fontWeight: "bold",
                      padding: "4px 0",
                      width: "40%",
                    }}
                  >
                    Total Cases:
                  </td>
                  <td style={{ padding: "4px 0" }}>
                    {poDetails?.totalCasesCount}
                  </td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold", padding: "4px 0" }}>
                    Total Pallets:
                  </td>
                  <td style={{ padding: "4px 0" }}>
                    {poDetails?.totalPalletCount}
                  </td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold", padding: "4px 0" }}>
                    Total Bases:
                  </td>
                  <td style={{ padding: "4px 0" }}>
                    {poDetails?.totalBasesCount}
                  </td>
                </tr>
              </tbody>
            </table>
          </td>

          {/* Delivery Information */}
          <td
            style={{
              width: "25%",
              border: "1px solid black",
              padding: "8px",
              verticalAlign: "top",
              backgroundColor: "#fff",
            }}
          >
            <div
              style={{
                fontWeight: "bold",
                fontSize: "16px",
                lineHeight: "20px",
              }}
            >
              Delivery Information
            </div>
            <hr
              style={{
                border: "none",
                borderTop: "1px solid black",
                margin: "4px 0 8px 0",
              }}
            />
            <table style={{ width: "100%", fontSize: "14px" }}>
              <tbody>
                <tr>
                  <td style={{ fontWeight: "bold", padding: "4px 0" }}>
                    Location Name:
                  </td>
                  <td style={{ padding: "4px 0" }}>
                    {poDetails?.shipToLocationName ||
                      getDestinationName(
                        locationResponse,
                        poDetails?.shipToLocationId
                      )}
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
    <table
      style={{
        width: "100%",
        borderCollapse: "collapse",
        textAlign: "center",
      }}
    >
      <thead>
        <tr
          style={{
            borderTop: "2px solid black",
            borderBottom: "2px solid black",
          }}
        >
          <th style={{ padding: "8px", textAlign: "left" }}>PIN</th>
          <th style={{ padding: "8px", textAlign: "left" }}>Description</th>
          <th style={{ padding: "8px" }}>Order Qty (Cases)</th>
          <th style={{ padding: "8px" }}>Order Qty (Pallets)</th>
        </tr>
      </thead>
      <tbody>
        {poDetails?.items
          ?.filter(
            (item) => item.status !== "remove" && item.status !== "cancelled"
          )
          .map((item, idx) => (
            <tr key={idx}>
              <td style={{ padding: "4px", textAlign: "left" }}>
                {item.packId}
              </td>
              <td style={{ padding: "4px", textAlign: "left" }}>
                {item.itemDescription}
              </td>
              <td style={{ padding: "4px" }}>{item.quantityOrdered}</td>
              <td style={{ padding: "4px" }}>{item.palletQuantity}</td>
            </tr>
          ))}
      </tbody>
    </table>
  </div>
);
